import { render, staticRenderFns } from "./ColumnAdd.vue?vue&type=template&id=8b46bbda&scoped=true&"
import script from "./ColumnAdd.vue?vue&type=script&lang=js&"
export * from "./ColumnAdd.vue?vue&type=script&lang=js&"
import style0 from "./ColumnAdd.vue?vue&type=style&index=0&id=8b46bbda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b46bbda",
  null
  
)

export default component.exports